import { Button, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	title: string;
	description: string;
	confirmLabel: string;
	cancelLabel: string;
	destructive?: boolean;
	onConfirm: () => void;
	onClose: () => void;
};

export const ConfirmDrawer: FC<Props> = ({
	open,
	title,
	description,
	confirmLabel,
	cancelLabel,
	destructive,
	onConfirm,
	onClose,
}) => (
	<MyPlannDrawer
		anchor="bottom"
		open={open}
		onClose={onClose}
		title={title}
		closeButton
	>
		<Stack px={2} pb={2} gap={2}>
			<Typography variant="body2">{description}</Typography>
			<Stack gap={1}>
				{destructive ? (
					<Button variant="tertiary" color="error" onClick={onConfirm}>
						{confirmLabel}
					</Button>
				) : (
					<Button variant="primary" onClick={onConfirm}>
						{confirmLabel}
					</Button>
				)}
				<Button variant="tertiary" onClick={onClose}>
					{cancelLabel}
				</Button>
			</Stack>
		</Stack>
	</MyPlannDrawer>
);
